export const getRoleLabel = (role: string) => {
  if (role === 'admin') return 'Admin';
  if (role === 'navigator') return 'Navigator';
  if (role === 'caseManager') return 'Case Manager';
  if (role === 'trainer') return 'Trainer';
  if (role === 'superAdmin') return 'Super Admin';
  if (role === 'employer') return 'Employer';
  if (role === 'employmentLiaison') return 'Employment Liaison';
};
